import React from "react";
import { fmtDateTime, titleCase } from "@/lib/format";
import { PageHeader, DataTable, Pager, useList } from "@/components/shared";
import { ScrollText } from "lucide-react";

export default function Audit() {
  const { items, total, loading, page, setPage } = useList("/audit", {});
  const columns = [
    { key: "timestamp", header: "Time", render: (r) => <span className="text-sm text-muted-foreground whitespace-nowrap">{fmtDateTime(r.timestamp)}</span> },
    { key: "user_name", header: "User", render: (r) => <div><div className="font-semibold text-sm">{r.user_name}</div><div className="font-mono text-xs text-muted-foreground">{r.employee_id}</div></div> },
    { key: "action", header: "Action", render: (r) => <span className="text-sm font-medium">{titleCase(r.action)}</span> },
    { key: "module", header: "Module", render: (r) => <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-muted">{r.module}</span> },
    { key: "record_ref", header: "Record", render: (r) => <span className="font-mono text-xs">{r.record_ref || "—"}</span> },
    { key: "reason", header: "Reason", render: (r) => <span className="text-sm text-muted-foreground">{r.reason || "—"}</span> },
  ];
  return (
    <div>
      <PageHeader title="Audit Log" subtitle={`${total} recorded actions · user, action, record & timestamp`} icon={ScrollText} />
      <DataTable columns={columns} rows={items} loading={loading} rowTestId="audit-table-row" />
      <Pager page={page} limit={25} total={total} onPage={setPage} />
    </div>
  );
}
